const KST = { timeZone: "Asia/Seoul" };

export const formatDate = (v) =>
  v ? new Date(v).toLocaleDateString("ko-KR", KST) : "-";

export const formatDateTime = (v) =>
  v ? new Date(v).toLocaleString("ko-KR", KST) : "-";

export const formatDateTimeShort = (v) =>
  v ? new Date(v).toLocaleString("ko-KR", { ...KST, month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" }) : "-";
